export default "__VITE_ASSET__Bhc0QQRg__"